import Vue from 'vue';
import App from './App';
import router from './router';

import './assets/css/fonts.css';
import './assets/css/normalize.css';
import './assets/css/milligram.min.css';
import './assets/css/main.css';
import './assets/css/animation.css';
import './assets/css/fontello.css';

router.start(App, '#app');

export { App, router };



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/